import type { RouteObject } from 'react-router-dom';

import { AuthLayout } from '@/features/authLayout';
import { AboutPage } from '@/pages/about';
import { ImpersonationExchangePage } from '@/pages/impersonation-exchange';
import { AccountSettingsPage } from '@/pages/account-settings';
// Features
import { AffiliatePage } from '@/pages/affiliate';
import { AnalyticsPage } from '@/pages/analytics';
import { CampaignsPage } from '@/pages/campaigns';
import { AiTracePage } from '@/pages/aiTrace';
// Channels
import { ChannelsPage } from '@/pages/channels';
import { ChannelSettingsPage } from '@/pages/channelSettings';
import { ChatsPage } from '@/pages/chats';
// Companies
import { CompaniesPage } from '@/pages/companies';
import {
  ChannelsOfCompanyTab as ChannelsOfCompanyPage,
  CompanySettingsPage,
} from '@/pages/company';
// Other
import { FAQPage } from '@/pages/faq';
import { ForgotPassword } from '@/pages/forgotPassword';
// Main Pages
import { HomePage } from '@/pages/home';
import { IntegrationsPage } from '@/pages/integrations';
// Auth
import { LoginPage } from '@/pages/login';
import { NotFoundPage } from '@/pages/not-found';
import { NotificationsPage } from '@/pages/notifications';
import { PaymentErrorPage } from '@/pages/payment-error';
import { PaymentSuccessPage } from '@/pages/payment-success';
import { RegisterPage } from '@/pages/register';
import { ResetPassword } from '@/pages/resetPassword';
import { ShareQrPage } from '@/pages/shareQr';
import { SubscriptionsPage } from '@/pages/subscriptions';
import { TemplatesPage } from '@/pages/templates';
import { CodeVerification } from '@/pages/verifyCode';
import { ROUTES_PATH } from '@/shared/constants/routes';

import { PrivateLayout } from './layouts';
import { isSupportImpersonationRouteEnabled } from './support-impersonation-route';

const supportImpEnabled = isSupportImpersonationRouteEnabled();

export const appRoutes: Array<RouteObject> = [
  {
    path: ROUTES_PATH.MAIN.INDEX,
    element: <PrivateLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { index: true, element: <ChannelsPage /> },
      {
        path: ROUTES_PATH.MAIN.CHANNELS,
        element: <ChannelsPage />,
      },
      {
        path: ROUTES_PATH.MAIN.CHANNEL,
        element: <ChannelSettingsPage />,
      },
      { path: ROUTES_PATH.MAIN.COMPANIES, element: <CompaniesPage /> },
      { path: ROUTES_PATH.MAIN.CAMPAIGNS, element: <CampaignsPage /> },
      {
        path: ROUTES_PATH.MAIN.COMPANY_SETTINGS,
        element: <CompanySettingsPage />,
      },
      { path: ROUTES_PATH.MAIN.INTEGRATIONS, element: <IntegrationsPage /> },
      { path: ROUTES_PATH.MAIN.SUBSCRIPTIONS, element: <SubscriptionsPage /> },
      { path: ROUTES_PATH.MAIN.AFFILIATE, element: <AffiliatePage /> },
      { path: ROUTES_PATH.MAIN.TEMPLATES, element: <TemplatesPage /> },
      { path: ROUTES_PATH.MAIN.NOTIFICATIONS, element: <NotificationsPage /> },
      { path: ROUTES_PATH.MAIN.ANALYTICS, element: <AnalyticsPage /> },
      { path: ROUTES_PATH.MAIN.AI_TRACE, element: <AiTracePage /> },
      { path: ROUTES_PATH.MAIN.ABOUT, element: <AboutPage /> },
      {
        path: ROUTES_PATH.MAIN.ACCOUNT_SETTINGS,
        element: <AccountSettingsPage />,
      },
      { path: ROUTES_PATH.MAIN.FAQ, element: <FAQPage /> },
      { path: ROUTES_PATH.MAIN.CHATS, element: <ChatsPage /> },
      {
        path: ROUTES_PATH.MAIN.PAYMENT_SUCCESS,
        element: <PaymentSuccessPage />,
      },
      {
        path: ROUTES_PATH.MAIN.PAYMENT_FAIL,
        element: <PaymentErrorPage />,
      },
      {
        path: ROUTES_PATH.MAIN.PAYMENT_ERROR,
        element: <PaymentErrorPage />,
      },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
  {
    path: ROUTES_PATH.AUTH.INDEX,
    element: <AuthLayout />,
    children: [
      { index: true, element: <LoginPage /> },
      { path: ROUTES_PATH.AUTH.LOGIN, element: <LoginPage /> },
      { path: ROUTES_PATH.AUTH.REGISTER, element: <RegisterPage /> },
      { path: ROUTES_PATH.AUTH.VERIFY_CODE, element: <CodeVerification /> },
      { path: ROUTES_PATH.AUTH.FORGOT_PASSWORD, element: <ForgotPassword /> },
      { path: ROUTES_PATH.AUTH.RESET_PASSWORD, element: <ResetPassword /> },
    ],
  },
  { path: ROUTES_PATH.MAIN.QR_AUTH, element: <ShareQrPage /> },
  {
    path: '/impersonation/exchange',
    element: supportImpEnabled ? <ImpersonationExchangePage /> : <NotFoundPage />,
  },
  { path: '*', element: <NotFoundPage /> },
  // { path: '/auth', element: <AuthPage /> },
];
